export const UPDATE_GUESTS = '/EventGuests/*/UpdateGuests';
export const UPDATE_GUESTS_UI = '/EventGuests/*/UpdateGuestsUI';
